import { StarRatingProps } from './star-rating-props.interface';
import classNames from 'classnames';
import React from 'react';
import RankStarEmpty from 'src/assets/images/icons/custom-icons/RankStarEmpty';
import RankStarFull from 'src/assets/images/icons/custom-icons/RankStarFullOrange';
import RankStarHalf from 'src/assets/images/icons/custom-icons/RankStarHalfOrange';

/**
 * Modern StarRating Component
 *
 * A beautifully designed star rating component with smooth animations and modern styling.
 * Features clean design patterns to match the overall website aesthetic.
 */
const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  // Calculate the number of full stars
  const fullStars = Math.floor(rating);
  // Determine if there is a half star
  const hasHalfStar = rating % 1 > 0 && rating % 1 < 1;

  return (
    <div className="flex gap-1 items-center">
      {Array.from(
        { length: 5 },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        (_, i) => {
          const starClasses = classNames('h-6 w-6 transition-all duration-200 ease-out', 'hover:scale-110');

          // Render full stars
          if (i < fullStars) {
            return <RankStarFull key={i} className={starClasses} />;
            // Render half star if applicable
          } else if (i === fullStars && hasHalfStar) {
            return <RankStarHalf key={i} className={starClasses} />;
            // Render empty stars
          } else {
            return <RankStarEmpty key={i} className={starClasses} />;
          }
        }
      )}
    </div>
  );
};

export default StarRating;
